<template>
  <transition name="modal" appear>
    <!-- popup (s) -->
    <div id="bottomPop" class="popWrap nowOpen">
      <div class="popup">
        <div class="popContain">
          <div class="popCont bottom exhibit open" tabindex="-1" role="dialog">
            <div class="popHead">
              <h1 class="titH1">특별기획전</h1>
            </div>
            <div class="popBody">
              <div class="popInner">
                <!-- 본문 (s) -->
                <section class="full">
                  <div class="slide centered bulletXS_1" id="gnb_slide_1">
                    <ul class="slideList">
                      <li v-for="(banner, index) in bannerList" :key="index">
                        <a class="img">
                          <img :src="banner.imgURL" />
                        </a>
                      </li>
                      <!-- <li>
                        <a class="img">
                          <img src="https://www.welrixrental.co.kr//img_1/board/event/thumbnail/1604275658217_01.jpg" />
                        </a>
                      </li>
                      <li>
                        <a class="img">
                          <img src="https://www.welrixrental.co.kr//img_1/board/event/thumbnail/1604277475125_1598613155578_200828_pcs_9e_slg.jpg" />
                        </a>
                      </li> -->
                    </ul>
                  </div>
                </section>
              </div>
            </div>
            <button type="button" class="btnTxt_cookie" @click="$emit('closeToday')"><span>오늘은 그만 보기</span></button>
            <button type="button" class="btnTxt_close" @click="$emit('close')">
              <span>닫기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import * as customjs from '@/../static/js/m.front.js';
import ApiService from '@/common/api.service';
export default {
  name: 'BottomPop',
  data() {
    return {
      bannerList: [],
    };
  },
  async mounted() {
    const vm = this;
    await ApiService.service('GET', '/resource/banner/17')
      .then(({ data }) => {
        console.log(data);
        this.bannerList = data.result[0].bannerDtos;
      })
      .catch(({ response }) => {
        console.log(response);
      });
    customjs.slideInit('#gnb_slide_1', 0, false, 300, true, 'auto', 8, null, vm.clickEvent);
  },
  methods: {
    // goEventDetail(idx) {
    //   console.log(idx);
    //   this.$router.push({ name: 'eventDetail', params: { idx: idx } });
    // },
    clickEvent(index) {
      const params = {
        af_content_id: index + 1,
      };
      //const appsFlyerParams = JSON.stringify(params);
      window.appsFlyer('af_main_toast_banner', params);
      this.$router.push(this.bannerList[index].bannerUrl);
      // if (index == 0) this.$router.push({ name: 'eventDetail', params: { idx: 21 } });
      // else if (index == 1) this.$router.push({ name: 'eventDetail', params: { idx: 20 } });
      // else this.$router.push({ name: 'eventDetail', params: { idx: 11 } });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './css/popup.styl';
</style>
